<template>
    <div class="navigationContainer">
        <div class="nav-box box-shadow">
            <div class="navigationPanel" id="navigationPanel"></div>
            <div class="nav-btn">
                <el-button icon="el-icon-close" size="mini" circle @click="onClose" ></el-button>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    methods:{
        onClose(){
            this.$emit('close');
        },
        onSuccess(){
            setTimeout(() => {
                var panel = document.querySelector("#navigationPanel");
                var scrollHeight = panel.scrollHeight;
                if(scrollHeight > 600){
                    panel.style.overflowY = "scroll";
                }else{
                    panel.style.overflowY = "";
                }
                //console.log('height', panel, panel.scrollHeight);
            }, 100);
        }
    }
};
</script>

<style lang="scss">
.navigationContainer{
    position: absolute; right:5px; top:100px; width:360px; text-align:left;
    line-height:30px;
    .plan dt.route {
        line-height:25px !important;
    }
    .navigationPanel{
        max-height:600px;
        .amap-call{
            text-align:left; color:#000; padding-left:12px;
        }
    }
    .nav-box{
        position: relative;
        .nav-btn{
            position: absolute; right:10px; top:2px;
        }
    }
}

</style>